<div class="ui-modal ui-modal--compact">
  <div class="header flex-row space-between-center">
    <div>{{ options.title | translate: options.params }}</div>
    @if (!options.hideCancel) {
      <span
        class="ui-icon-close c-p"
        (click)="
          !!options.returnOnClose
            ? close(options.returnOnClose)
            : close(ConfirmDialogSelection.CANCEL)
        "
      ></span>
    }
  </div>
  <div class="body">
    <div
      [innerHTML]="options.msg | translate: options.params"
      class="msg"
    ></div>
    @if (!!options.description) {
      <div
        [innerHTML]="options.description | translate: options.params"
        class="description"
      ></div>
    }
  </div>
  <div class="footer flex-row end-center gap-8">
    @switch (options.type) {
      @case (ConfirmDialogType.INFO) {
        <ui-button
          type="default"
          (click)="close(ConfirmDialogSelection.CANCEL)"
          [text]="options.cancel || 'OK'"
        >
        </ui-button>
      }
      @case (ConfirmDialogType.CONFIRM) {
        @if (!options.hideCancel) {
          <ui-button
            type="default"
            (click)="close(ConfirmDialogSelection.CANCEL)"
            [text]="(options.cancel | translate) || 'COMMON.CANCEL' | translate"
          ></ui-button>
        }
        <ui-button
          type="primary"
          (clickAction)="close(ConfirmDialogSelection.OK)"
          [text]="(options.confirm | translate) || 'OK'"
        ></ui-button>
      }
    }
  </div>
</div>
